import React, { useContext, useEffect, useMemo, useState } from 'react';
import Select, { components } from 'react-select';
import { useQuery, useLazyQuery } from '@apollo/client';
import ButtonV2 from 'components/common/ButtonV2';
import { axiosGetAPI } from 'services';
import { authContext } from 'contexts/AuthContext';
import { CITY_BY_STATE, STATES_BY_COUNTRY } from 'pages/MarketListing/MarketListingGraphQL';
import MatrixDetailView from './MatrixDetailView';

const INDIA_COUNTRY_ID = '101';
let cachedCityOptions = null;

/* ------------------------------------------------------------------ */
/* Static Data                                                         */
/* ------------------------------------------------------------------ */
const CITIES = [
  'Ahmedabad', 'Bangalore', 'Bhiwandi', 'Chennai', 'Delhi',
  'Guwahati', 'Hyderabad', 'Indore', 'Kanpur', 'Kochi',
  'Kolkata', 'Mangalore', 'Mundra', 'Nagpur', 'Nhava Sheva',
  'Raipur', 'Vapi', 'Varanasi', 'Vishakhapatnam',
];

export const BASE_RATES = {
  Ahmedabad: { Ahmedabad: null, Bangalore: 8, Bhiwandi: 3, Chennai: 9, Delhi: 5, Guwahati: '', Hyderabad: 6, Indore: 4, Kanpur: '', Kochi: '', Kolkata: '', Mangalore: 7, Mundra: 2, Nagpur: 5, 'Nhava Sheva': 3, Raipur: '', Vapi: 2, Varanasi: '', Vishakhapatnam: '' },
  Bangalore: { Ahmedabad: 8, Bangalore: null, Bhiwandi: 6, Chennai: 4, Delhi: '', Guwahati: '', Hyderabad: 3, Indore: '', Kanpur: '', Kochi: 5, Kolkata: '', Mangalore: 4, Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: 7 },
  Bhiwandi: { Ahmedabad: 3, Bangalore: 6, Bhiwandi: null, Chennai: 7, Delhi: 5, Guwahati: '', Hyderabad: 5, Indore: 3, Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: 4, 'Nhava Sheva': 2, Raipur: 5, Vapi: 2, Varanasi: '', Vishakhapatnam: '' },
  Chennai: { Ahmedabad: 9, Bangalore: 4, Bhiwandi: 7, Chennai: null, Delhi: '', Guwahati: '', Hyderabad: 4, Indore: '', Kanpur: '', Kochi: 5, Kolkata: '', Mangalore: 5, Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: 6 },
  Delhi: { Ahmedabad: 5, Bangalore: '', Bhiwandi: 5, Chennai: '', Delhi: null, Guwahati: '', Hyderabad: '', Indore: 4, Kanpur: 3, Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: 5, Vishakhapatnam: '' },
  Guwahati: { Ahmedabad: '', Bangalore: '', Bhiwandi: '', Chennai: '', Delhi: '', Guwahati: null, Hyderabad: '', Indore: '', Kanpur: '', Kochi: '', Kolkata: 6, Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Hyderabad: { Ahmedabad: 6, Bangalore: 3, Bhiwandi: 5, Chennai: 4, Delhi: '', Guwahati: '', Hyderabad: null, Indore: '', Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: 4, 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: 5 },
  Indore: { Ahmedabad: 4, Bangalore: '', Bhiwandi: 3, Chennai: '', Delhi: 4, Guwahati: '', Hyderabad: '', Indore: null, Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: 3, 'Nhava Sheva': '', Raipur: 4, Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Kanpur: { Ahmedabad: '', Bangalore: '', Bhiwandi: '', Chennai: '', Delhi: 3, Guwahati: '', Hyderabad: '', Indore: '', Kanpur: null, Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: 4, Vishakhapatnam: '' },
  Kochi: { Ahmedabad: '', Bangalore: 5, Bhiwandi: '', Chennai: 5, Delhi: '', Guwahati: '', Hyderabad: '', Indore: '', Kanpur: '', Kochi: null, Kolkata: '', Mangalore: 4, Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Kolkata: { Ahmedabad: '', Bangalore: '', Bhiwandi: '', Chennai: '', Delhi: '', Guwahati: 6, Hyderabad: '', Indore: '', Kanpur: '', Kochi: '', Kolkata: null, Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: 5, Vishakhapatnam: 6 },
  Mangalore: { Ahmedabad: 7, Bangalore: 4, Bhiwandi: '', Chennai: 5, Delhi: '', Guwahati: '', Hyderabad: '', Indore: '', Kanpur: '', Kochi: 4, Kolkata: '', Mangalore: null, Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Mundra: { Ahmedabad: 2, Bangalore: '', Bhiwandi: '', Chennai: '', Delhi: '', Guwahati: '', Hyderabad: '', Indore: '', Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: null, Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: 3, Varanasi: '', Vishakhapatnam: '' },
  Nagpur: { Ahmedabad: 5, Bangalore: '', Bhiwandi: 4, Chennai: '', Delhi: '', Guwahati: '', Hyderabad: 4, Indore: 3, Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: null, 'Nhava Sheva': '', Raipur: 3, Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  'Nhava Sheva': { Ahmedabad: 3, Bangalore: '', Bhiwandi: 2, Chennai: '', Delhi: '', Guwahati: '', Hyderabad: '', Indore: '', Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': null, Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Raipur: { Ahmedabad: '', Bangalore: '', Bhiwandi: 5, Chennai: '', Delhi: '', Guwahati: '', Hyderabad: '', Indore: 4, Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: '', Nagpur: 3, 'Nhava Sheva': '', Raipur: null, Vapi: '', Varanasi: '', Vishakhapatnam: '' },
  Vapi: { Ahmedabad: 2, Bangalore: '', Bhiwandi: 2, Chennai: '', Delhi: '', Guwahati: '', Hyderabad: '', Indore: '', Kanpur: '', Kochi: '', Kolkata: '', Mangalore: '', Mundra: 3, Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: null, Varanasi: '', Vishakhapatnam: '' },
  Varanasi: { Ahmedabad: '', Bangalore: '', Bhiwandi: '', Chennai: '', Delhi: 5, Guwahati: '', Hyderabad: '', Indore: '', Kanpur: 4, Kochi: '', Kolkata: 5, Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: null, Vishakhapatnam: '' },
  Vishakhapatnam: { Ahmedabad: '', Bangalore: 7, Bhiwandi: '', Chennai: 6, Delhi: '', Guwahati: '', Hyderabad: 5, Indore: '', Kanpur: '', Kochi: '', Kolkata: 6, Mangalore: '', Mundra: '', Nagpur: '', 'Nhava Sheva': '', Raipur: '', Vapi: '', Varanasi: '', Vishakhapatnam: null },
};

export const SCALE = {
  'Mini Truck (1 Ton)': 1.0,
  'Small Truck (2 Ton)': 0.90,
  'Medium Truck (5 Ton)': 0.78,
  'Large Truck (10 Ton)': 0.65,
  'Container (20 Ton)': 0.55,
  'Container (32 Ton)': 0.48,
  'Trailer (40 Ton)': 0.42,
};

export const getRate = (vehicle, origin, dest) => {
  const base = BASE_RATES[origin]?.[dest];
  if (base === null) return null;
  if (base === '' || base === undefined) return '';
  return Math.round(base * (SCALE[vehicle] || 1) * 10) / 10;
};

const getCleanName = (item) => {
  if (!item) return '';
  if (item.cityName) return item.cityName.trim().toLowerCase();
  if (item.label) return item.label.replace(/\s*\(.*?\)\s*$/, '').trim().toLowerCase();
  return String(item.value || '').trim().toLowerCase();
};

const isValidRateValue = (rate) => {
  if (rate === null || rate === undefined || rate === '' || rate === 'null' || rate === 'undefined') {
    return false;
  }
  const num = Number(rate);
  return !Number.isNaN(num) && num > 0;
};

const isSameCityPair = (row, destCity) => {
  if (!row || !destCity) return false;
  const rowId = String(row.originCityId ?? '');
  const destId = String(destCity.cityId ?? '');
  if (rowId && destId && rowId === destId) return true;

  const rowName = (row.originCityName || '').trim().toLowerCase();
  const destName = (destCity.cityName || '').trim().toLowerCase();
  return Boolean(rowName && destName && rowName === destName);
};

const hasValidCellRate = (row, destCity) => {
  if (!row || !destCity) return false;
  if (isSameCityPair(row, destCity)) return false;

  const destId = String(destCity.cityId ?? '');
  const destName = (destCity.cityName || '').trim().toLowerCase();

  const cell = row.cells?.find(
    (c) =>
      (destId && String(c.destinationCityId ?? '') === destId) ||
      (destName && c.destinationCityName && c.destinationCityName.trim().toLowerCase() === destName)
  );

  return isValidRateValue(cell?.perKgRate);
};


/* ── react-select styles ── */
const selectStyles = {
  control: (base, state) => ({
    ...base,
    height: '42px',
    minHeight: '42px',
    maxHeight: '42px',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    borderColor: state.isFocused ? '#1d4ed8' : '#d0d5dd',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(29,78,216,0.1)' : 'none',
    borderRadius: '8px',
    fontSize: '14px',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    '&:hover': { borderColor: '#1d4ed8' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
    height: '40px',
    maxHeight: '40px',
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    alignItems: 'center',
    position: 'relative',
    minWidth: 0,
    flex: '1 1 0%',
    scrollbarWidth: 'thin',
    scrollbarColor: '#cbd5e1 transparent',
    '&::-webkit-scrollbar': { height: '3px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#cbd5e1', borderRadius: '3px' },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '40px',
    flexShrink: 0,
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#eff4ff',
    border: '1px solid #c7d7fe',
    borderRadius: '6px',
    margin: '2px 4px 2px 0',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    maxWidth: '180px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#1d4ed8',
    fontSize: '12px',
    fontWeight: 600,
    padding: '2px 6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#1d4ed8',
    padding: '0 4px',
    cursor: 'pointer',
    borderRadius: '0 5px 5px 0',
    '&:hover': {
      backgroundColor: '#dbeafe',
      color: '#1e40af',
    },
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: '#101828',
    visibility: 'visible',
    flex: '0 0 auto',
    minWidth: '2px',
  }),
  placeholder: (base) => ({
    ...base,
    position: 'absolute',
    left: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#98a2b3',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#101828',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  }),
  option: (base, state) => {
    let backgroundColor = '#fff';
    if (state.isSelected) backgroundColor = '#eff4ff';
    else if (state.isFocused) backgroundColor = '#f8fafc';

    return {
      ...base,
      fontSize: '14px',
      backgroundColor,
      color: state.isSelected ? '#1d4ed8' : '#101828',
      fontWeight: state.isSelected ? 600 : 400,
      cursor: 'pointer',
    };
  },
  menu: (base) => ({ ...base, borderRadius: '8px', boxShadow: '0 8px 24px rgba(16,24,40,0.12)', zIndex: 99999 }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  indicatorSeparator: () => ({ display: 'none' }),
};

/* ── Inline styles ── */
const thStyle = {
  padding: '10px 14px',
  fontWeight: 700,
  fontSize: '12px',
  color: '#475467',
  background: '#f2f4f7',
  borderBottom: '2px solid #e4e7ec',
  borderRight: '1px solid #e4e7ec',
  whiteSpace: 'nowrap',
};

const rowHeaderStyle = {
  ...thStyle,
  position: 'sticky',
  left: 0,
  zIndex: 2,
  borderRight: '2px solid #e4e7ec',
  textAlign: 'left',
  minWidth: '120px',
};

const tdStyle = {
  padding: '10px 14px',
  fontSize: '13px',
  color: '#344054',
  borderBottom: '1px solid #e9ecef',
  borderRight: '1px solid #e9ecef',
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

const tdDiagonalStyle = {
  ...tdStyle,
  background: '#f2f4f7',
  color: '#98a2b3',
  fontWeight: 600,
};

const tdRateStyle = {
  ...tdStyle,
  color: '#1d4ed8',
  fontWeight: 700,
  background: '#eff4ff',
  cursor: 'pointer',
};

const tdClickableStyle = {
  ...tdStyle,
  cursor: 'pointer',
};

/* ------------------------------------------------------------------ */
/* Component                                                           */
/* ------------------------------------------------------------------ */
const MatrixTab = ({ setHeaderActions }) => {
  const { auth } = useContext(authContext);
  const [origin, setOrigin] = useState([]);
  const [destination, setDestination] = useState([]);
  const [cityOptions, setCityOptions] = useState(cachedCityOptions || []);
  const [citiesLoading, setCitiesLoading] = useState(!cachedCityOptions);

  const [vehicleType, setVehicleType] = useState(null);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [vehicleOptionsLoading, setVehicleOptionsLoading] = useState(true);
  const [searched, setSearched] = useState(false);
  const [selected, setSelected] = useState(null); // { origin, dest }
  const [showAllMatrix, setShowAllMatrix] = useState(false);

  const [matrixData, setMatrixData] = useState(null);
  const [isMatrixLoading, setIsMatrixLoading] = useState(false);

  const { data: statesData, loading: statesLoading } = useQuery(STATES_BY_COUNTRY, {
    variables: { country: INDIA_COUNTRY_ID },
    fetchPolicy: 'cache-first',
  });
  const [fetchCitiesByState] = useLazyQuery(CITY_BY_STATE, { fetchPolicy: 'cache-first' });

  useEffect(() => {
    if (cachedCityOptions && cachedCityOptions.length > 0) {
      setCityOptions(cachedCityOptions);
      setCitiesLoading(false);
      return undefined;
    }

    const states = statesData?.statesByCountry || [];
    if (!states.length) return undefined;
    let isMounted = true;
    setCitiesLoading(true);

    const loadAllCities = async () => {
      try {
        const cityResults = await Promise.all(
          states.map(async (state) => {
            try {
              const response = await fetchCitiesByState({
                variables: { state: state.id },
              });
              return (response?.data?.citiesByState || []).map((city) => ({
                value: String(city.id),
                cityName: city.cityName,
                stateName: state.stateName,
                stateId: String(state.id),
                label: `${city.cityName} (${state.stateName})`,
              }));
            } catch (err) {
              console.error(`Error loading cities for state ${state.stateName}:`, err);
              return [];
            }
          }),
        );

        const allCities = cityResults
          .flat()
          .sort((a, b) => a.cityName.localeCompare(b.cityName));

        cachedCityOptions = allCities;

        if (isMounted) {
          setCityOptions(allCities);
          setCitiesLoading(false);
        }
      } catch (err) {
        console.error('Error loading all cities:', err);
        if (isMounted) setCitiesLoading(false);
      }
    };

    loadAllCities();

    return () => {
      isMounted = false;
    };
  }, [fetchCitiesByState, statesData]);

  const handleSwap = () => {
    const prev = origin;
    setOrigin(destination);
    setDestination(prev);
    setSearched(false);
  };

  const handleSearch = async () => {
    if (!vehicleType) return;
    setIsMatrixLoading(true);
    setSearched(true);
    setSelected(null);
    setShowAllMatrix(false);
    try {
      let url = `${process.env.REACT_APP_REST_API_ENDPOINT}delivery-rate/v2/matrix?vehicleSize=${vehicleType.value}`;
      if (origin && origin.length > 0) {
        origin.forEach((o) => {
          if (o?.value) url += `&originCityId=${o.value}`;
        });
      }
      if (destination && destination.length > 0) {
        destination.forEach((d) => {
          if (d?.value) url += `&destinationCityId=${d.value}`;
        });
      }
      const response = await axiosGetAPI(url, auth);
      if (response?.isSuccessful && response?.data?.data) {
        setMatrixData(response.data.data);
      } else {
        setMatrixData({ cities: [], rows: [] });
      }
    } catch (error) {
      console.error('Error fetching matrix data:', error);
      setMatrixData({ cities: [], rows: [] });
    } finally {
      setIsMatrixLoading(false);
    }
  };

  const handleReset = () => {
    setOrigin([]);
    setDestination([]);
    setVehicleType(null);
    setSearched(false);
    setSelected(null);
    setMatrixData(null);
    setShowAllMatrix(false);
  };

  const handleCellClick = (row, destCity, cell) => {
    setSelected({
      origin: row.originCityName,
      dest: destCity.cityName,
      originCityId: row.originCityId,
      destinationCityId: destCity.cityId,
      routeId: cell ? (cell.routeId || cell.id || cell.deliveryRouteId || cell.route?.id) : null,
    });
  };

  useEffect(() => {
    let isMounted = true;

    const fetchVehicleSizes = async () => {
      setVehicleOptionsLoading(true);
      const response = await axiosGetAPI(
        `${process.env.REACT_APP_REST_API_ENDPOINT}delivery-rate/v2/vehicle-sizes`,
        auth,
      );

      if (isMounted && response?.isSuccessful) {
        setVehicleOptions(
          (response?.data?.data || []).map((vehicle) => ({
            value: vehicle.value,
            label: vehicle.label,
            tonnage: vehicle.tonnage,
          })),
        );
      }

      if (isMounted) setVehicleOptionsLoading(false);
    };

    fetchVehicleSizes();

    return () => {
      isMounted = false;
    };
  }, [auth]);

  useEffect(() => {
    if (!selected) return undefined;

    setHeaderActions(
      <button type="button" className="sr-reset-btn list-tab-back-button" onClick={() => setSelected(null)}>
        ‹&nbsp; Back to Matrix
      </button>,
    );

    return () => setHeaderActions(null);
  }, [selected, setHeaderActions]);

  const hasOriginFilter = Boolean(origin && origin.length > 0);
  const hasDestFilter = Boolean(destination && destination.length > 0);
  const hasFilter = Boolean(!showAllMatrix && (hasOriginFilter || hasDestFilter));

  const baseRows = useMemo(() => {
    if (!hasFilter || !hasOriginFilter) {
      return matrixData?.rows || [];
    }

    // Strictly show ONLY selected origins
    return origin.map((o) => {
      const oValue = String(o.value);
      const oName = getCleanName(o);

      const existingRow = matrixData?.rows?.find((r) => {
        const rowId = String(r.originCityId);
        const rowName = (r.originCityName || '').trim().toLowerCase();
        return rowId === oValue || rowName === oName;
      });

      if (existingRow) {
        return existingRow;
      }

      const cleanLabel =
        o.cityName ||
        (o.label ? o.label.replace(/\s*\(.*?\)\s*$/, '').trim() : '') ||
        String(o.value);

      return {
        originCityId: o.value,
        originCityName: cleanLabel,
        cells: [],
      };
    });
  }, [matrixData, origin, hasFilter, hasOriginFilter]);

  const baseCities = useMemo(() => {
    if (!hasFilter || !hasDestFilter) {
      return matrixData?.cities || [];
    }

    // Strictly show ONLY selected destinations
    return destination.map((d) => {
      const dValue = String(d.value);
      const dName = getCleanName(d);

      const existingCity = matrixData?.cities?.find((c) => {
        const cityId = String(c.cityId);
        const cityName = (c.cityName || '').trim().toLowerCase();
        return cityId === dValue || cityName === dName;
      });

      if (existingCity) {
        return existingCity;
      }

      const cleanLabel =
        d.cityName ||
        (d.label ? d.label.replace(/\s*\(.*?\)\s*$/, '').trim() : '') ||
        String(d.value);

      return {
        cityId: d.value,
        cityName: cleanLabel,
      };
    });
  }, [matrixData, destination, hasFilter, hasDestFilter]);

  // Only show columns that have at least one valid rate from visible rows
  const filteredCities = useMemo(() => {
    return baseCities.filter((destCity) =>
      baseRows.some((row) => hasValidCellRate(row, destCity))
    );
  }, [baseCities, baseRows]);

  // Only show rows that have at least one valid rate to visible columns
  const filteredRows = useMemo(() => {
    return baseRows.filter((row) =>
      baseCities.some((destCity) => hasValidCellRate(row, destCity))
    );
  }, [baseRows, baseCities]);

  // Total active non-empty rows and columns across the full matrix
  const allAvailableRows = useMemo(() => {
    const allRows = matrixData?.rows || [];
    const allCities = matrixData?.cities || [];
    return allRows.filter((r) => allCities.some((c) => hasValidCellRate(r, c)));
  }, [matrixData]);

  const allAvailableCities = useMemo(() => {
    const allRows = matrixData?.rows || [];
    const allCities = matrixData?.cities || [];
    return allCities.filter((c) => allRows.some((r) => hasValidCellRate(r, c)));
  }, [matrixData]);


  /* ── Detail view ── */
  if (selected) {
    return (
      <MatrixDetailView
        origin={selected.origin}
        dest={selected.dest}
        originCityId={selected.originCityId}
        destinationCityId={selected.destinationCityId}
        routeId={selected.routeId}
        vehicleType={vehicleType?.value}
      />
    );
  }

  const renderMatrixContent = () => {
    if (isMatrixLoading) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', color: '#667085' }}>
          Loading matrix...
        </div>
      );
    }
    if (matrixData && filteredCities?.length > 0 && filteredRows?.length > 0) {
      return (
        <div className="push-notification__table-wrap mx-matrix-table-wrap" style={{ borderRadius: 0, border: 0 }}>
          <table
            className="push-notification__table"
            style={{
              width: '100%',
              minWidth: 'max-content',
              fontSize: '13px',
            }}
          >
            <thead>
              <tr>
                <th style={{ ...thStyle, position: 'sticky', top: 0, left: 0, zIndex: 5, minWidth: '130px', verticalAlign: 'bottom', background: '#f2f4f7' }}>
                  <div style={{ fontSize: '10px', textAlign: 'right', color: '#98a2b3', fontWeight: 600 }}>DEST →</div>
                  <div style={{ fontSize: '10px', textAlign: 'left', color: '#98a2b3', fontWeight: 600, marginTop: 4 }}>↓ ORIGIN</div>
                </th>
                {filteredCities.map((city) => (
                  <th
                    key={city.cityId}
                    style={{
                      ...thStyle,
                      position: 'sticky',
                      top: 0,
                      zIndex: 3,
                      textAlign: 'center',
                    }}
                  >
                    {city.cityName}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row, rowIdx) => (
                <tr key={row.originCityId} style={{ background: rowIdx % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={rowHeaderStyle}>
                    {row.originCityName}
                  </td>
                  {filteredCities.map((destCity) => {
                    const cell = row.cells?.find(
                      (c) =>
                        String(c.destinationCityId ?? '') === String(destCity.cityId ?? '') ||
                        (c.destinationCityName && destCity.cityName &&
                          c.destinationCityName.trim().toLowerCase() === destCity.cityName.trim().toLowerCase())
                    );
                    const rate = cell ? cell.perKgRate : null;

                    const isSameCity =
                      String(row.originCityId ?? '') === String(destCity.cityId ?? '') ||
                      (row.originCityName && destCity.cityName &&
                        row.originCityName.trim().toLowerCase() === destCity.cityName.trim().toLowerCase());

                    if (isSameCity) {
                      return <td key={destCity.cityId} style={tdDiagonalStyle}>—</td>;
                    }
                    if (!isValidRateValue(rate)) {
                      return (
                        <td
                          key={destCity.cityId}
                          style={tdClickableStyle}
                          title={`${row.originCityName} → ${destCity.cityName} (Click to add rate)`}
                          aria-label={`Add rate from ${row.originCityName} to ${destCity.cityName}`}
                          onClick={() => handleCellClick(row, destCity, cell)}
                        />
                      );
                    }
                    return (
                      <td
                        key={destCity.cityId}
                        style={tdRateStyle}
                        title={`${row.originCityName} → ${destCity.cityName} — click to edit`}
                        onClick={() => handleCellClick(row, destCity, cell)}
                      >
                        ₹{rate}/kg
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#667085' }}>
        No rate data available for the selected criteria.
      </div>
    );
  };

  return (
    <div className="mx-wrap">

      {/* Filter Card */}
      <div className="sr-filter-card">
        <div className="sr-filter-grid">

          {/* Origin */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="matrix-origin">Origin</label>
            <Select
              inputId="matrix-origin"
              options={cityOptions}
              value={origin}
              onChange={(val) => { setOrigin(val || []); setSearched(false); }}
              placeholder="Select Origin"
              styles={selectStyles}
              formatOptionLabel={(opt, { context }) => {
                if (context === 'value') {
                  return opt.cityName || opt.label?.replace(/\s*\(.*?\)\s*$/, '').trim() || opt.label;
                }
                return opt.label;
              }}
              isMulti
              closeMenuOnSelect={false}
              blurInputOnSelect={false}
              isLoading={statesLoading || citiesLoading}
              isClearable
              menuPortalTarget={typeof document === 'undefined' ? null : document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Swap button */}
          <div className="sr-swap-btn-wrap">
            <button
              type="button"
              className="sr-swap-btn"
              onClick={handleSwap}
              title="Swap Origin & Destination"
              aria-label="Swap origin and destination"
              disabled={(!origin || origin.length === 0) && (!destination || destination.length === 0)}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 7h16M4 7l4-4M4 7l4 4" />
                <path d="M20 17H4M20 17l-4-4M20 17l-4 4" />
              </svg>
            </button>
          </div>

          {/* Destination */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="matrix-destination">Destination</label>
            <Select
              inputId="matrix-destination"
              options={cityOptions}
              value={destination}
              onChange={(val) => { setDestination(val || []); setSearched(false); }}
              placeholder="Select Destination"
              styles={selectStyles}
              formatOptionLabel={(opt, { context }) => {
                if (context === 'value') {
                  return opt.cityName || opt.label?.replace(/\s*\(.*?\)\s*$/, '').trim() || opt.label;
                }
                return opt.label;
              }}
              isMulti
              closeMenuOnSelect={false}
              blurInputOnSelect={false}
              isLoading={statesLoading || citiesLoading}
              isClearable
              menuPortalTarget={typeof document === 'undefined' ? null : document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Vehicle Type */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="matrix-vehicle">
              Vehicle Type <span className="text-danger">*</span>
            </label>
            <Select
              inputId="matrix-vehicle"
              options={vehicleOptions}
              value={vehicleType}
              onChange={(val) => { setVehicleType(val); setSearched(false); }}
              placeholder="Select Vehicle Type"
              styles={selectStyles}
              isLoading={vehicleOptionsLoading}
              isDisabled={vehicleOptionsLoading}
              isClearable
              menuPortalTarget={typeof document === 'undefined' ? null : document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Search Button */}
          <div className="sr-field sr-field--btn">
            <ButtonV2
              color="primary"
              style={{ height: '42px', padding: '0 28px', fontSize: '14px', fontWeight: 700, borderRadius: '8px', width: '100%' }}
              onClick={handleSearch}
              disabled={!vehicleType || isMatrixLoading}
            >
              {isMatrixLoading ? 'Searching...' : 'Search'}
            </ButtonV2>
          </div>

        </div>
      </div>

      {/* Matrix Table */}
      {searched && (
        <div className="push-notification-container mx-matrix-card" style={{ padding: 0, gap: 0, animation: 'srFadeIn 0.3s ease' }}>

          {/* Title */}
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #e4e7ec', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: '14px', fontWeight: 700, color: '#1d2939' }}>Delivery Rate Matrix</span>
            <span style={{ fontSize: '12px', color: '#667085', fontWeight: 500 }}>{vehicleType?.label} &nbsp;·&nbsp; ₹ / kg</span>
            <span style={{ fontSize: '11px', color: '#98a2b3', marginLeft: 'auto' }}>Click any cell to view / edit rate</span>
          </div>

          {/* Filter notice if filtered by Origin/Destination */}
          {hasFilter && (
            <div style={{
              padding: '8px 16px',
              background: '#eff4ff',
              borderBottom: '1px solid #d1e0ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: '12px',
              color: '#1d4ed8',
              flexWrap: 'wrap',
              gap: 8,
            }}>
              <span>
                Filtered by: <strong>{hasOriginFilter ? origin.map((o) => o.cityName || o.label).join(', ') : 'All Origins'}</strong> → <strong>{hasDestFilter ? destination.map((d) => d.cityName || d.label).join(', ') : 'All Destinations'}</strong>
              </span>
              <button
                type="button"
                onClick={() => setShowAllMatrix(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1570ef',
                  fontWeight: 600,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 0,
                }}
              >
                View Full Matrix ({allAvailableRows.length} × {allAvailableCities.length})
              </button>
            </div>
          )}

          {showAllMatrix && (hasOriginFilter || hasDestFilter) && (
            <div style={{
              padding: '8px 16px',
              background: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: '12px',
              color: '#475467',
              flexWrap: 'wrap',
              gap: 8,
            }}>
              <span>Showing full matrix</span>
              <button
                type="button"
                onClick={() => setShowAllMatrix(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1570ef',
                  fontWeight: 600,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 0,
                }}
              >
                Back to Filtered View
              </button>
            </div>
          )}

          {/* Table */}
          {renderMatrixContent()}

          {/* Legend + Reset */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #e4e7ec', background: '#fafafa', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
              {[
                { label: 'Rate available (click to edit)', bg: '#eff4ff', border: '#c7d7fe' },
                { label: 'No direct route (click to add)', bg: '#fafafa', border: '#e2e8f0' },
                { label: 'Same city', bg: '#f2f4f7', border: '#e4e7ec' },
              ].map((item) => (
                <span key={item.label} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: '12px', color: '#475467' }}>
                  <span aria-hidden="true" style={{ width: 12, height: 12, borderRadius: 3, background: item.bg, border: `1.5px solid ${item.border}`, display: 'inline-block', flexShrink: 0 }} />
                  {item.label}
                </span>
              ))}
            </div>
            <button type="button" className="sr-reset-btn" onClick={handleReset}>Reset</button>
          </div>

        </div>
      )}

      {/* Empty prompt */}
      {!searched && (
        <div className="sr-prompt">
          <div className="sr-prompt-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <line x1="3" y1="9" x2="21" y2="9" />
              <line x1="9" y1="3" x2="9" y2="21" />
            </svg>
          </div>
          <p className="sr-prompt-text">
            Select Origin, Destination & Vehicle Type, then click <strong>Search</strong> to view the rate matrix.
          </p>
        </div>
      )}

    </div>
  );
};

export default MatrixTab;
